var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicineActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24.004,
    height: 24,
    rx: 4,
    fill: "#86CA9D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 11a3.97 3.97 0 0 0-2 .541V8.5a3.5 3.5 0 1 0-7 0v7a3.5 3.5 0 0 0 6.143 2.294A4 4 0 1 0 15 11zm0 1a3.003 3.003 0 0 1 2.955 2.5h-5.91A3.003 3.003 0 0 1 15 12zM7 8.5a2.5 2.5 0 1 1 5 0v3H7v-3zM9.5 18A2.503 2.503 0 0 1 7 15.5v-3h4.883a3.979 3.979 0 0 0-.363 4.466A2.494 2.494 0 0 1 9.5 18zm5.5 0a3.003 3.003 0 0 1-2.955-2.5h5.91A3.003 3.003 0 0 1 15 18z",
    fill: "#020002"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicineActiveIcon);
export default __webpack_public_path__ + "static/media/medicineActiveIcon.7d2895de3253586e7cc1081ab1d27f04.svg";
export { ForwardRef as ReactComponent };